import { useEffect, useState } from 'react';
import { envIsElectron, envIsTesting } from 'src/const/envCheck';

const useNFCDeviceConnection = () => {
  const [isNFCDeviceConnected, setIsNFCDeviceConnected] = useState(false);

  useEffect(() => {
    if (!envIsElectron) {
      if (!envIsTesting)
        console.warn(
          'useNFCDeviceConnection hook is available only in Electron environment',
        );
      return;
    }

    const { ipcRenderer } = window.electron;

    ipcRenderer.sendMessage('requestNFCPortStatus');

    const handleNFCPortStatus = (NFCDeviceConnectionStatus: unknown) => {
      const castNFCDeviceConnectionStatus =
        NFCDeviceConnectionStatus as boolean;
      setIsNFCDeviceConnected(castNFCDeviceConnectionStatus);
    };

    const unsubscribeNFCPortStatus = ipcRenderer.on(
      'sendNFCPortStatus',
      handleNFCPortStatus,
    );

    return () => {
      unsubscribeNFCPortStatus();
    };
  }, []);

  return isNFCDeviceConnected;
};

export { useNFCDeviceConnection };
